export function setLoading(state, payload){
  state.loading = payload
}